import { EventTypeEnum } from '@/types/replay/replay.types';

export const eventColor: Record<EventTypeEnum, string> = {
  [EventTypeEnum.LAD]: 'red',
  [EventTypeEnum.PERIMETER]: 'blue',
  [EventTypeEnum.OTHER]: 'yellow',
};
